module.exports = __webpack_public_path__ + "img/logo.247af00b.png";